import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHero, CTABand } from "@/components/Bits";

export default function Applications() {
  const [apps, setApps] = useState([]);
  useEffect(() => { api.get("/applications").then((r) => setApps(r.data)); }, []);
  return (
    <div>
      <PageHero eyebrow="Soluções por Aplicação" title="Encontramos a solução certa para o seu processo"
        subtitle="Do problema à solução: entenda como aplicamos nossos equipamentos em cada segmento."
        image="https://images.unsplash.com/photo-1581092163144-b7ae3c00adbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />
      <div className="mx-auto max-w-[1400px] px-4 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {apps.map((a) => (
            <Link key={a.slug} to={`/solucoes/${a.slug}`} data-testid={`app-card-${a.slug}`}
              className="group flex flex-col border border-[#27272A] bg-[#151618] transition-colors duration-200 hover:border-[#FF5500]">
              <div className="relative aspect-[16/10] overflow-hidden bg-black">
                <img src={a.image} alt={a.name} className="h-full w-full object-cover opacity-75 transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <h3 className="font-heading text-xl font-bold text-white">{a.name}</h3>
                <p className="mt-2 text-sm text-[#A1A1AA]">{a.solution}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <CTABand />
    </div>
  );
}
